namespace TabAurous.ECommerce {
    export interface ECommRepairTaxForm {
        TransId: Serenity.StringEditor;
        HSN: Serenity.StringEditor;
        ProductTypeId: Serenity.IntegerEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxId: Serenity.IntegerEditor;
        TaxRate: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
    }

    export class ECommRepairTaxForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommRepairTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommRepairTaxForm.init)  {
                ECommRepairTaxForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(ECommRepairTaxForm, [
                    'TransId', w0,
                    'HSN', w0,
                    'ProductTypeId', w1,
                    'NetAmount', w2,
                    'TaxId', w1,
                    'TaxRate', w2,
                    'TaxAmount', w2
                ]);
            }
        }
    }
}
